import { Component, Input, OnInit,AfterViewInit,ViewEncapsulation, ViewChild  } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { TopProductsComponent } from '../../shared/top-products/top-products.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None 
})
export class homeComponent implements OnInit,AfterViewInit  {
  public config: SwiperConfigInterface = {};
  @ViewChild(TopProductsComponent) topProductComponent!: TopProductsComponent;

  constructor(public router: Router,) { }
  @Input() displayProducts = [
    {
      img: "../../../../assets/images/productRating/product1.png",
      startext:
        "Sometimes Change is necessary and I found mine here.",
      author: "DR. JACOB",
      type: "Customer",
      small: true,
      medium: false,
      left: false,
      leftbig: false,
      boxTitle: 'COMMON SENSE',
      boxContent: 'Loyalty Rewards Program'
    },
    {
      img: "../../../../assets/images/productRating/product2.png",
      startext:
        "I thank God I found a company that cares more about it's distributor's and customers than it does about itself.",
      author: "PAULA WANGNER",
      type: "Customer",
      small: true,
      medium: false,
      left: false,
      leftbig: false,
      boxTitle: 'COMMON SENSE',
      boxContent: 'Loyalty Rewards Program'
    },
    {
      img: "../../../../assets/images/productRating/product3.png",
      startext:
        "Super products, especially now when we need to keep our immune system strong!",
      author: "DR. KARL ANDERSON",
      type: "BrainSense",
      small: true,
      medium: false,
      left: false,
      leftbig: false,
      boxTitle: 'COMMON SENSE',
      boxContent: 'Loyalty Rewards Program'
    },
    {
      img: "../../../../assets/images/productRating/product1.png",
      startext:
        "This is the best tasting mangosteen drink I have tried. I crave it everyday.",
      author: "ROBIN",
      type: "Customer",
      small: true,
      medium: false,
      left: false,
      leftbig: false,
      boxTitle: 'COMMON SENSE',
      boxContent: 'Loyalty Rewards Program'
    },
   ];
   ngOnInit(): void {
    window.scroll(0,0);
   }  
  ngAfterViewInit():void {
    this.config = {
      mousewheel:false,
      observer: true,
      slidesPerView: 1,
      spaceBetween: 10,
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,
      loop: true,
      preloadImages: true,
    };
      
    // Select multiple sections by their IDs or classes
  const childDivId = this.topProductComponent.targetDivId;
const targetSections = document.querySelectorAll('.top-products-details, #discover-more-quote, #exp-freedom-text-section, .testimonial-cards, #loyality-reward-program,#bottom-section123');

// Create an observer
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      switch (entry.target.id || entry.target.className) {

        case 'discover-more-quote':
          document.getElementById('discover-hidden-content').classList.add('animate-zoomIn');
          break;
          
        case 'exp-freedom-text-section':
          document.getElementById('exp-freedom-text-section').classList.add('animate-slideInLeft');
          break;

        case 'loyality-reward-program':
          document.getElementById('loyality-reward-program').style.opacity = '0.95';
          break;
        case 'bottom-section123':
          document.getElementById('bottom-section123').classList.add('animate-slideInUp');
          break;
      }

      // If it's the testimonial cards section, apply animation to each card individually
      if (entry.target.classList.contains('testimonial-cards')) {
        document.querySelectorAll('.testimonial-cards').forEach((element) => {
          element.classList.add('animate-slideInUp');
        });
      }

      if (entry.target.classList.contains('top-products-details')) {
        document.getElementById(`${childDivId}`)?.classList.add('animate-zoomIn');
      }

      // Stop observing this section after the animation is applied to prevent it from re-triggering
      observer.unobserve(entry.target);
    }
  });
}, { threshold: 0.5 });

// Observe each section
targetSections.forEach(section => {
  observer.observe(section);
});

  }

  NavigateToDiscoverProducts(redirection){
    this.router.navigate([redirection]);
  }
}

